import { Moment } from 'moment';
import { apiGet, apiPost, apiPut, API_URI } from './index';

const sentiment = {
  getAll: async (projectId: number, startDate: Moment, endDate: Moment, streamIds: number[]) => {
        const data = await apiGet(`${API_URI}/api/sentiment/getall?projectId=${projectId}&startDate=${startDate.format("DD MMM YYYY HH:mm")}&endDate=${endDate.format("DD MMM YYYY HH:mm")}&streamIds=${streamIds.join(",")}`);
        return data;
    }
}

export default sentiment;